import React, { useEffect } from "react";
import { useHistoryOperations } from "@/hooks/useHistoryOperations";
import { EntityHistory } from "@/components/common/EntityHistory";

interface MatchHistoryTabProps {
	matchId: string;
}

export const MatchHistoryTab = ({ matchId }: MatchHistoryTabProps) => {
	const { history, loading, fetchHistory } = useHistoryOperations('match');

	// Fetch history when component mounts
	useEffect(() => {
		if (matchId) {
			fetchHistory(matchId);
		}
	}, [matchId, fetchHistory]);

	return (
		<div>
			<h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">Match History</h3>
			<EntityHistory history={history} loading={loading} />
		</div>
	);
};
